<div class="btn-block">
  <button
    *ngIf="isEnableUpload"
    (click)="uploadFilter()"
    class="btn">
    <svg class="btn__icon stroke" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99935 2.6665V9.33317M7.99935 2.6665L10.666 5.33317M7.99935 2.6665L5.33268 5.33317M2.66602 13.3332H13.3327"
        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  <button
    [class.active]="isOpenFilter"
    (click)="toggleFilter()"
    class="btn">
    <svg class="btn__icon fill" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4301_17997)">
        <path
          d="M4.66667 4H11.3333L7.99333 8.2L4.66667 4ZM2.83333 3.74C4.18 5.46667 6.66667 8.66667 6.66667 8.66667V12.6667C6.66667 13.0333 6.96667 13.3333 7.33333 13.3333H8.66667C9.03333 13.3333 9.33333 13.0333 9.33333 12.6667V8.66667C9.33333 8.66667 11.8133 5.46667 13.16 3.74C13.5 3.3 13.1867 2.66667 12.6333 2.66667H3.36C2.80667 2.66667 2.49333 3.3 2.83333 3.74Z"/>
      </g>
      <defs>
        <clipPath id="clip0_4301_17997">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </button>
</div>

